import React from "react";
import Stack from "@mui/material/Stack";
import { Theme } from "../../data/style/Theme";
import { CenteredRow, MainText, SmallTitle } from "../../data/style/Style";

const DatePanel = ({ label, date }) => {
  return (
    <CenteredRow
      gap={1}
      p={1}
      sx={{
        borderRadius: 4,
        border: 1,
        borderColor: Theme.palette.orange,
        background: Theme.palette.orange + "07",
      }}
    >
      <MainText>📅</MainText>
      <Stack gap={0.5}>
        <SmallTitle fontSize={"0.6rem"}>{label}:</SmallTitle>
        <MainText>{date}</MainText>
      </Stack>
    </CenteredRow>
  );
};

export default DatePanel;
